export interface User {
  id: string;
  accountId: string;
  externalId: string;
  type: UserType;
  moderator: boolean;
  email: string;
  emailPreferences: EmailPreference[];
  username: string;
  imageFileSetId: string;
  imageUrl: string;
  createdAt: Date;
  firstName: string;
  lastName: string;
  phone: string;
  birthday: string;
  zipCode: string;
  /** the account's official author this user is linked to by email, when they are one */
  officialAuthor?: OfficialAuthor;
}

export interface OfficialAuthor {
  id: string;
  name: string;
  imageUrl?: string;
}

export enum UserType {
  CUSTOMER = 'CUSTOMER',
  WALLET = 'WALLET',
}

export interface UserUpdateRequest {
  username: string;
  imageFileSetId: string;
  emailPreferences: EmailPreference[];
  firstName?: string;
  lastName?: string;
  phone: string;
  birthday: string;
  zipCode: string;
}

export interface EmailPreference {
  id: string;
  type: EmailPreferencesType;
  enabled: boolean;
}

export enum EmailPreferencesType {
  POST_NOTIFICATIONS = 'POST_NOTIFICATIONS',
  COMMENT_NOTIFICATIONS = 'COMMENT_NOTIFICATIONS',
}
